module.exports = __webpack_public_path__ + "static/assets/2c90030680a2fafd21f53fd39a0862e7.otf";